// ============================================================
// DEMO VIDEO CONFIGURATION
// ============================================================
//
// Single source of truth for the homepage "See InsightPulse AI
// in action" video.
//

const DEMO_VIDEO_URL =
  "https://www.youtube.com/watch?v=UnUH3qqr9VY";

export { DEMO_VIDEO_URL };

// Extracts a YouTube video ID from common URL shapes.
function extractYouTubeId(url) {
  if (!url) return null;

  try {
    const parsed = new URL(url);

    if (parsed.hostname.includes("youtu.be")) {
      return parsed.pathname.slice(1) || null;
    }

    if (parsed.hostname.includes("youtube.com")) {
      if (parsed.pathname === "/watch") {
        return parsed.searchParams.get("v");
      }

      if (parsed.pathname.startsWith("/embed/")) {
        return parsed.pathname.split("/embed/")[1] || null;
      }

      if (parsed.pathname.startsWith("/shorts/")) {
        return parsed.pathname.split("/shorts/")[1] || null;
      }
    }
  } catch {
    return null;
  }

  return null;
}

// Returns a ready-to-embed YouTube URL.
export function getDemoVideoEmbedUrl() {
  const id = extractYouTubeId(DEMO_VIDEO_URL);

  if (!id) return null;

  return `https://www.youtube-nocookie.com/embed/${id}`;
}